import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Image from '../images/videos.png'
import Loading from '../images/loading.png'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { Triangle } from 'react-loader-spinner';



  class UserHome extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        user_details: {},
        videos: [],
        loading: true
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.DeleteVideo = (plan_id) => {
        this.setState({loading: true})
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('video_id', this.props.match.params.plan_id)

        axios.post(Backend_Url + 'deleteVideo', data)
        .then((res) => {
            let result = res.data
            alert('Video Deleted.')
            this.setState({loading: false})
            window.location.reload()
        }).catch((error) => {
            console.log(error)
            this.DeleteVideo(plan_id)
        })
      }

      this.CheckForVideos = () => {
        var user = this.state.user_details

        var videos = this.state.videos
        var videos_map = videos.map((video, index) => {
            return<Row style={{width: '557px', margin: '5px', height: '340px', overflow: 'hidden', marginBottom: '35px'}}>
                <Col>
                <video controls style={{width: '100vw', height: '315px'}}>
                    <source src={Backend_Url + 'media/' + video.video} type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
                <br/>
                <p style={{fontWeight: 'bold'}}>
                    {video.name}
                </p>
                <br/><br/>
                {
                    user.role == 'admin'
                    ?<div style={{textAlign: 'left'}}>
                        <Button onClick={() => this.DeleteVideo(video._id.$oid)} style={{color: '#ffffff', fontWeight: 'bold', border: '3px solid red', borderRadius: '20px', backgroundColor: 'red'}}>
                            Delete Video
                        </Button>
                        <br/><br/>
                    </div>
                    :<div>

                    </div>
                }
                </Col>
            </Row>
        })

        if(videos.length == 0){
          return<div>
            <br/>
            <h4 style={{marginTop: '30px', textAlign: 'center'}}>
              No content has been uploaded yet.
            </h4>
            <img src={Image} style={{width: '40%'}}/>
          </div>
        }else{
          return<Row style={{marginTop: '80px'}}>
              {videos_map}
          </Row>
        }
      }
    }

    componentDidMount() {
      const { cookies } = this.props;

      if(cookies.get('token') == null){
        let port = (window.location.port ? ':' + window.location.port : '');
        window.location.href = '//' + window.location.hostname + port + '/signin';
      }else{
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))

        axios.get(Backend_Url + 'getUserDetailsByAccessToken/' + cookies.get('token'))
        .then(res => {
            if (res.data != 'Not authorized'){
              this.setState({
              user_details: res.data
              });
            }
        })
        .catch((error) => {
            console.log(error);
        });
  
        axios.post(Backend_Url + 'homeVideos', data)
        .then((res) => {
            let result = res.data
            this.setState({videos: result, loading: false})
        }).catch((error) => {
            console.log(error)
        })
      }
    }




    render() {
      if(this.state.loading){
        return (
          <div style={{minHeight: '550px'}}>
              <Helmet>
                <title>USER HOME - ONFIT</title>
                {/* <meta name="description" content="" /> */}
              </Helmet>
              <br/>
              <Container>
                  <br/>
                  <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                      ONFIT
                  </h1>
                  <br/><br/>
                  <Triangle
                      color="#1FACED"
                      height={130}
                      width={130}
                  />
                  <h3 style={{marginTop: '50px'}}>
                  Loading...
                  </h3>
                  <h6 style={{marginTop: '50px'}}>
                      Taking too long to load? Check your internet connection and reload the page.
                  </h6>
                  <br/><br/>
              </Container>
          </div>
        );
      }
      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>USER HOME - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{minHeight: '550px'}}>
              <br/><br/>
              <h6 style={{color: '#47525E', fontWeight: 'bold', fontFamily: 'Knewave', textAlign: 'left', fontSize: '50px', marginLeft: '40px'}}>
                ONFIT
              </h6>
              <Container>
                <this.CheckForVideos/>
              </Container>
              <br/><br/><br/>
            </div>
        </div>
      );
    }

  };
  
  export default withCookies(UserHome);